// Types matching the expected backend API shapes for external sharing.
// These mirror the ShareRequest/ShareResponse from ConversationRecapRpc
// and the response shape from ConversationRecapPublicRpc in the backend RFC

export const ShareableAsset = {
  AI_SUMMARY: 'AI_SUMMARY',
  TRANSCRIPT: 'TRANSCRIPT',
  VIDEO_RECORDING: 'VIDEO_RECORDING',
  AUDIO_RECORDING: 'AUDIO_RECORDING'
};

// Sent to ConversationRecapRpc.share()

// Data shape for a single participant on the public page

// Each section of the public page has its own loading/error state,
// following the multiple endpoint approach discussed in RFC.
// Some of these fields we could condense to a `metadata` field instead?